// lib/utils.js
import { z } from "zod";

const formValidationSchema = z.object({
  name: z.string()
    .min(1, "Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters")
    .regex(/^[a-zA-Z\s'-]+$/, "Name can only contain letters, spaces, hyphens, and apostrophes"),
    
  email: z.string()
    .min(1, "Email is required")
    .email("Please enter a valid email address")
    .max(100, "Email must be less than 100 characters"),
    
  message: z.string()
    .min(1, "Message is required")
    .max(1000, "Message must be less than 1000 characters"),
    
  date: z.string()
    .min(1, "Date is required")
    .refine((date) => {
      const inputDate = new Date(date);
      const today = new Date();
      today.setHours(23, 59, 59, 999); // Set to end of today
      return inputDate <= today;
    }, "Date cannot be in the future"),
    
  time: z.string()
    .min(1, "Time is required")
    .regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Please enter a valid time (HH:MM)"),
    
  problem: z.string()
    .min(1, "Please select the problem"),
    
  waitTime: z.string()
    .min(1, "Please select wait time"),
    
  howDriverKnew: z.string()
    .min(1, "Please select how driver knew"),
    
  vehicleLocation: z.string()
    .min(1, "Please select vehicle location"),
    
  serviceTime: z.string()
    .min(1, "Please select service time"),
    
  driverName: z.string()
    .min(1, "Driver name is required")
    .min(2, "Driver name must be at least 2 characters")
    .max(50, "Driver name must be less than 50 characters"),
  
  safetyRating: z.string()
    .min(1, "Please rate the driver's concern for your safety"),
    
  professionalismRating: z.string()
    .min(1, "Please rate the driver's professionalism"),
    
  overallRating: z.string()
    .min(1, "Please provide an overall service rating")
});

export const validateFormData = (formData) => {
  try {
    formValidationSchema.parse(formData);
    return { isValid: true, errors: {} };
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errors = {};
      error.errors.forEach((err) => {
        if (err.path[0]) {
          errors[err.path[0]] = err.message;
        }
      });
      return { isValid: false, errors };
    }
    return { isValid: false, errors: { general: "Validation failed" } };
  }
};